import React from "react";
import "./InfoStrip.css";

const OPEN_ACCOUNT = {
  cdc: "https://www.asaanconnect.com/cdc/cgp/r/centralized-gateway-portal/home",
  orbit: "https://www.aof.com.pk/?MTg2MjgyNTQzNzY0OTc5MjI4MzQyODYyNTI1NDY4NjQ4NDYyNzcyNw==",
};

const PhoneIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);
const AccountIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <circle cx="10" cy="13" r="2" /><path d="M13.5 16.5 12 15" />
  </svg>
);
const MailIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="5" width="18" height="14" rx="2" /><polyline points="3 7 12 13 21 7" />
  </svg>
);
const ClockIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="9" /><polyline points="12 7 12 12 15.5 14" />
  </svg>
);

const Item = ({ icon, label, children }) => (
  <div className="istrip-item">
    <div className="istrip-icon">{icon}</div>
    <div className="istrip-text">
      <div className="istrip-label">{label}</div>
      <div className="istrip-value">{children}</div>
    </div>
  </div>
);

const InfoStrip = () => (
  <section className="istrip">
    <div className="istrip-inner">
      <Item icon={<PhoneIcon />} label="Call Us">
        <div>+92-333-529-9117</div>
        <div>+92-333-529-9121</div>
      </Item>

      <span className="istrip-divider" />

      <Item icon={<AccountIcon />} label="Open New Account">
        <a href={OPEN_ACCOUNT.cdc} target="_blank" rel="noopener noreferrer" className="istrip-link plain">Via CDC</a>
        <span className="istrip-sep">|</span>
        <a href={OPEN_ACCOUNT.orbit} target="_blank" rel="noopener noreferrer" className="istrip-link">Via Orbit</a>
      </Item>

      <span className="istrip-divider" />

      <Item icon={<MailIcon />} label="Email Us">
        <a href="mailto:info@orbitsecurities.com.pk" className="istrip-link plain">info@orbitsecurities.com.pk</a>
      </Item>

      <span className="istrip-divider" />

      <Item icon={<ClockIcon />} label="Working Hours">
        <div>Mon – Fri: 09:00 AM – 06:00 PM</div>
        <div>Saturday: 09:00 AM – 01:00 PM</div>
      </Item>
    </div>
  </section>
);

export default InfoStrip;
